import React, { useEffect, useState } from 'react';
import { Menu, X, Sun, Moon } from 'lucide-react';
export function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [isDarkMode, setIsDarkMode] = useState(false);
  useEffect(() => {
    // Check initial theme preference
    if (document.documentElement.classList.contains('dark')) {
      setIsDarkMode(true);
    }
  }, []);
  const toggleTheme = () => {
    setIsDarkMode(!isDarkMode);
    if (isDarkMode) {
      document.documentElement.classList.remove('dark');
    } else {
      document.documentElement.classList.add('dark');
    }
  };
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const navLinks = [{
    name: 'Home',
    href: '#home'
  }, {
    name: 'About',
    href: '#about'
  }, {
    name: 'Services',
    href: '#services'
  }, {
    name: 'Portfolio',
    href: '#portfolio'
  }, {
    name: 'GitHub',
    href: '#testimonials'
  }, {
    name: 'Contact',
    href: '#contact'
  }];
  return <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${isScrolled ? 'bg-dark/95 backdrop-blur-sm py-4 shadow-lg' : 'bg-transparent py-6'}`} data-id="element-132">
      <div className="max-w-[1320px] mx-auto px-4 flex justify-between items-center" data-id="element-133">
        <a href="#home" className="flex items-center" data-id="element-134">
          <img src="https://cdn.magicpatterns.com/uploads/5NTyxseHUpDeTNPmLZNFKL/ByteWeb8.png" alt="Byteweb" className="h-10 w-auto" data-id="element-135" />
        </a>

        {/* Desktop Menu */}
        <div className="hidden md:flex items-center space-x-8" data-id="element-136">
          {navLinks.map(link => <a key={link.name} href={link.href} className="font-inter text-sm font-medium text-white/80 hover:text-gold transition-colors uppercase tracking-wider" data-id="element-137">
              {link.name}
            </a>)}
        </div>

        {/* Theme Toggle & Mobile Menu */}
        <div className="flex items-center gap-4" data-id="element-138">
          <button onClick={toggleTheme} className="text-white hover:text-gold transition-colors p-2 rounded-full bg-white/5 border border-white/10" aria-label="Toggle theme" data-id="element-139">
            {isDarkMode ? <Sun size={20} data-id="element-140" /> : <Moon size={20} data-id="element-141" />}
          </button>

          <button className="md:hidden text-white hover:text-gold transition-colors" onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)} data-id="element-142">
            {isMobileMenuOpen ? <X size={24} data-id="element-143" /> : <Menu size={24} data-id="element-144" />}
          </button>
        </div>
      </div>

      {/* Mobile Menu Overlay */}
      {isMobileMenuOpen && <div className="md:hidden absolute top-full left-0 right-0 bg-dark border-t border-white/10 p-4 flex flex-col space-y-4 shadow-xl" data-id="element-145">
          {navLinks.map(link => <a key={link.name} href={link.href} className="font-inter text-base font-medium text-white/80 hover:text-gold transition-colors block py-2" onClick={() => setIsMobileMenuOpen(false)} data-id="element-146">
              {link.name}
            </a>)}
        </div>}
    </nav>;
}